import React from 'react';
import {Alert, Button} from "antd";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {InfoCircleOutlined} from "@ant-design/icons";

function LmsLevelIdNeedTakenUnitSection({levelDetail}) {


    return (

        <div>

            <Alert
                className={'flex flex-wrap'}
                rootClassName={'flex flex-wrap'}
                showIcon={true}
                icon={<InfoCircleOutlined/>}
                message="سلام"
                type="info"
                description={
                    <>

                        برای دسترسی به این مرحله باید در کلاس‌های
                        {' '}
                        <b>

                            {levelDetail?.data?.data?.group?.topic?.title}
                        </b>
                        {' '}
                        ثبت نام کرده باشید
                        <div className={'m-2'}>
                            <Link
                                to={URLS.student.lessons.take + '?topic_id=' + levelDetail?.data?.data?.group?.topic?.id}>
                                <Button size="small" type="primary">
                                    ثبت‌نام

                                </Button>
                            </Link>

                        </div>

                    </>}


            />

        </div>
    );
}

export default LmsLevelIdNeedTakenUnitSection;